module.exports = __webpack_public_path__ + "img/not-authorized-dark.5cc73bae.svg";